import type { MouseEventHandler } from 'react'
import React, { useCallback } from 'react'

import SelectTripModalView from '../TripModal/SelectTripModalView'

import {
  tripLoginModalSignUpDismiss,
  tripLoginModalSignUpView,
} from 'analytics/eventDefinitions'
import { fireInteractionEvent } from 'api/googleTagManager'
import TextButton from 'LuxKit/Button/TextButton'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import useLoginBeforeCallback from 'hooks/usePendingLoginHandler'
import { SAVE_ITEM_COPY } from 'tripPlanner/config'
import { usePublicTrip } from 'tripPlanner/hooks/api/publicTrip'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import type { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
  tripId: string
  className?: string
  label?: string
}

const trackTripLoginModalSignUpView = () => {
  fireInteractionEvent(tripLoginModalSignUpView('save_public_trip_item'))
}
const trackTripLoginModalSignUpDismiss = () => {
  fireInteractionEvent(tripLoginModalSignUpDismiss('save_public_trip_item'))
}

function SavePublicTripItemButton({
  item,
  label = SAVE_ITEM_COPY,
  className,
  tripId,
}: Props) {
  const openModal = useOpenModal()

  const { data: trip } = usePublicTrip(tripId)

  const openTripSelect = useCallback(() => {
    if (trip) {
      openModal(SelectTripModalView, { item, trip })
    }
  }, [item, openModal, trip])

  const onSave = useLoginBeforeCallback(
    openTripSelect,
    'tripPlannerLogin',
    trackTripLoginModalSignUpView,
    trackTripLoginModalSignUpDismiss,
  )

  const onClick: MouseEventHandler = useCallback(
    (e) => {
      e.preventDefault()
      e.stopPropagation()

      onSave()
    },
    [onSave],
  )

  if (!trip) {
    return null
  }

  return (
    <TextButton
      kind="secondary"
      startIcon={<LineHeartIcon />}
      onClick={onClick}
      className={className}
    >
      {label}
    </TextButton>
  )
}

export default SavePublicTripItemButton
